import { render } from "./GalleryManagement.vue?vue&type=template&id=64d31ece&scoped=true&ts=true"
import script from "./GalleryManagement.vue?vue&type=script&lang=ts"
export * from "./GalleryManagement.vue?vue&type=script&lang=ts"

import "./GalleryManagement.vue?vue&type=style&index=0&id=64d31ece&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d31ece"]])

export default __exports__